module.exports = __webpack_public_path__ + "img/newLogo4.352d33ce.png";